export enum BankDetailCreateUpdateType {
  NoBankDetailsCreateUpdateAllowed = 'NoBankDetailsCreateUpdateAllowed',
  OutstandingAcceptedCreateVendorApplication = 'OutstandingAcceptedCreateVendorApplication',
  ManuallyCreatedVendor = 'ManuallyCreatedVendor',
  UpdateBankDetails = 'UpdateBankDetails',
}
